import type { SnakeToCamelCaseNested } from "@jti/fe-common";
import type { ApiMagentoDiscount } from "@jti/magento-types";

import type { IMoney } from "../types";

import type { Tax } from "./Tax";

export type OrderPrices = {
  appliedCampaign: {
    loyalty_discount_amount: number;
    loyalty_discount_points?: number;
    loyalty_discount_uuid: string;
  };
  appliedTaxes: Tax[];
  discounts: ApiMagentoDiscount[];
  grandTotal: IMoney;
  shipping?: IMoney;
  estimatedShippingCost?: IMoney;
  subtotal: IMoney;
  subtotalIncludingTax: IMoney;
  subscriptionAmount?: IMoney;
  minimumPayableAmount?: IMoney;
};

export type MagentoOrderPrices = SnakeToCamelCaseNested<OrderPrices>;
